import { render, staticRenderFns } from "./CheckboxV2.vue?vue&type=template&id=1cb3a08c&"
import script from "./CheckboxV2.vue?vue&type=script&lang=js&"
export * from "./CheckboxV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports